import axiosConfig from '@/data/utils/axiosConfigInstance';
import axios from 'axios';



const tagApi = {
	getAllTags: () => axiosConfig.get(`/get/tags`),
	getActiveTags: async () => {
		const response = await axiosConfig.get(`/get/tags`);
		return response.data.filter(tag => tag.priority > 0);
	},
	addTag: newTag => axiosConfig.post(`/add/tags`, { newTag }),
	deleteTag: deleteTag => axiosConfig.post(`/delete/tags`, { deleteTag })
};

export default tagApi;
